import { render, staticRenderFns } from "./InfluenciadoresIcon.vue?vue&type=template&id=2d534d2d&"
import script from "./InfluenciadoresIcon.vue?vue&type=script&lang=ts&"
export * from "./InfluenciadoresIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports